module.exports = __webpack_public_path__ + "img/EN.360fde28.png";